// Deterministic "Next Move" extractor.
// Returns an explicit Next Move string only if the saved note contains a clear
// "Next Move[…]:" prefix. Never guesses or infers from free-form notes.
//
// Accepted line shapes (case-insensitive):
//   Next Move: Finish the CTA
//   Next Move (first 60 seconds): Open the landing page draft
//   next move — Ship the pricing table copy
//
// Anything else returns null.
export const extractNextMove = (rawNote) => {
  if (!rawNote || typeof rawNote !== 'string') return null;
  const text = rawNote.replace(/\r\n/g, '\n');
  // Look for a "Next Move" label followed by optional parenthetical, then : / – / — and content
  const re = /(^|\n)\s*next\s*move\s*(\([^)\n]*\))?\s*[:\-–—]\s*([^\n]+)/i;
  const match = text.match(re);
  if (!match) return null;
  const value = (match[3] || '').trim();
  if (!value) return null;
  // Guard against a bare colon or filler like "None" / "N/A"
  if (/^(n\/a|none|-|–|—)$/i.test(value)) return null;
  return value;
};

// Inspect ONLY the single most recent session. If it has an explicit Next Move
// (structured or strict legacy parse), return it; otherwise return null.
// Never falls back to older sessions.
export const getLatestSessionWithNextMove = (sessions) => {
  if (!Array.isArray(sessions) || sessions.length === 0) return null;
  const sorted = [...sessions].sort((a, b) => {
    const da = new Date(a.created_at || a.session_date || 0).getTime();
    const db = new Date(b.created_at || b.session_date || 0).getTime();
    return db - da;
  });
  const latest = sorted[0];
  if (!latest) return null;
  const nm =
    (typeof latest.next_move === 'string' && latest.next_move.trim()) ||
    extractNextMove(latest.proof_note || latest.notes || '');
  return nm ? { session: latest, nextMove: nm } : null;
};
